import makeStyles from '@mui/styles/makeStyles'
import { DESKTOP_FONT_SIZE } from '@v4/constants/pages'

const useStyles = makeStyles(
	theme => ({
		root: {
			border: `1px ${theme.palette.scoreapp.border} solid`,
			backgroundColor: theme.palette.scoreapp.background,
			borderRadius: 4,
			color: theme.palette.scoreapp.text,
			fontSize: DESKTOP_FONT_SIZE.subtitle2,
			padding: theme.spacing(0, 1),
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)',
			fontWeight: 500,
			zIndex: 3,
			height: theme.spacing(3.25),
			width: theme.spacing(20),
			pointerEvents: 'all',
		},
		select: {
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			padding: 0,
			backgroundColor: `${theme.palette.scoreapp.background} !important`,

			'& .MuiSelect-nativeInput': {
				display: 'none',
			},
		},
		icon: {
			color: theme.palette.scoreapp.primary,
		},

		circle: {
			fontSize: 12,
			marginRight: 7,
		},

		paper: {
			backgroundColor: 'white',
			color: theme.palette.scoreapp.text,
			width: theme.spacing(20),
			transform: 'translate(-9px, 3px) !important',
			boxShadow: '0 2px 4px rgba(0, 0, 0, 0.06)',
			borderRadius: '0 0 4px 4px',
			border: `1px ${theme.palette.scoreapp.primary} solid`,
			borderTop: 'none',
		},
		list: {
			padding: 0,
		},

		item: {
			display: 'flex',
			alignItems: 'center',
			padding: theme.spacing(0.7, 1),
		},
		text: {
			textOverflow: 'ellipsis',
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			fontSize: 15,
			fontWeight: 400,
			fontFamily: 'Instrument Sans',
		},

		input: {
			paddingLeft: `${theme.spacing(0.9)} !important`,
			paddingBottom: `0 !important`,
			paddingTop: `0 !important`,
			minWidth: 'auto',
			display: 'flex',
			alignItems: 'center',
		},
	}),
	{ name: 'ScoreTierDropdown' },
)

export default useStyles
